<template>
  <div class="aside-layout">
    <div class="aside-container">
      <slot name="aside"></slot>
    </div>
    <el-divider direction="vertical"></el-divider>
    <div class="main-container">
      <slot>
        <router-view></router-view>
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.aside-layout {
  display: flex;
  min-height: 540px;
  padding-top: 15px;
  padding-bottom: 29px;

  .aside-container {
    width: 258px;
  }

  .el-divider {
    display: block;
    height: auto;
    margin: 0;
    background: #ccc;
  }

  .main-container {
    width: 720px;
    padding-top: 30px;
    padding-left: 25px;
    padding-right: 20px;
  }
}
</style>
